import { pageData, PageOptionsMeta } from "../../constants/pagedata";
import { TaskOption } from "../../types/tasks.types";

export const StepSix = function (props: { createStarted: boolean, pageSelected: string, contentSelected: string[], taskTitle: string, confirmCreateClick: () => void, updateOptions: (optID: string, index: number) => void, pageOptions: TaskOption[] }) {

	let allComplete = checkComplete(props.pageSelected, props.contentSelected, props.taskTitle);
	let incompleteData = getIncompleteSteps(props.pageSelected, props.contentSelected, props.taskTitle);
	let createDisabled = allComplete === false || props.createStarted === true;
	let createMsg = allComplete === true && props.createStarted === false ? "Click 'Create Task' to Confirm" : "";
	let incompleteMsg = incompleteData.count === 1 ? `Complete ${incompleteData.step}` : "Complete the other steps first";

	return (
		<div className='teachers-taskcreater-step'>
			<hr />
			<h3>Step 6{allComplete && '  - Complete'}
			</h3>
			{!allComplete && <p>{incompleteMsg}</p>}
			<PageOptions
				pageSelected={props.pageSelected}
				pageOptions={props.pageOptions}
				allComplete={allComplete}
				updateOptions={props.updateOptions} />
			{createMsg !== '' && <p>{createMsg}</p>}
			<button disabled={createDisabled} onClick={() => { props.confirmCreateClick(); }} className='teachers-taskcreater-button teachers-button'>Create Task</button>
		</div>
	)
};

function checkComplete(pageSelected: string, contentSelected: string[], taskTitle: string) {
	let allComplete = true;
	if (pageSelected === '') allComplete = false;
	let contentGroup = 0;
	if (pageSelected !== '') contentGroup = pageData[pageSelected].contentGroup;
	if (contentGroup !== 0 && contentSelected[0] === '') allComplete = false;
	if (taskTitle === '') allComplete = false;
	return allComplete;
}

function getIncompleteSteps(pageSelected: string, contentSelected: string[], taskTitle: string) {
	let incompleteCount = 0;
	let missingStep = '';
	if (pageSelected === '') {
		incompleteCount++;
		missingStep = 'Step 1 - Select a page';
	}
	let contentGroup = 0;
	if (pageSelected !== '') contentGroup = pageData[pageSelected].contentGroup;
	if (contentGroup !== 0 && contentSelected[0] === '') {
		incompleteCount++;
		missingStep = 'Step 2 - Select content';
	}
	if (taskTitle === '') {
		incompleteCount++;
		missingStep = "Step 3 - Enter task title";
	}
	return { count: incompleteCount, step: missingStep };
}

const PageOptions = function (props: { pageSelected: string, pageOptions: TaskOption[], allComplete: boolean, updateOptions: (optID: string, index: number) => void }) {
	if (!props.allComplete) return null;
	if (!pageData[props.pageSelected].pageOptionsMeta) return null;

	let myPageOptionsMeta = pageData[props.pageSelected].pageOptionsMeta;
	if (myPageOptionsMeta === undefined) {
		return null;
	} else {
		let options = myPageOptionsMeta.map((option: PageOptionsMeta, index: number) => {
			let myKey = 'options-' + index;
			return <OptionSet key={myKey} optionMeta={option} pageOptions={props.pageOptions} optionsIndex={index} updateOptions={props.updateOptions} />
		});
		return (
			<div>
				{options}
			</div>
		)
	}
};

const OptionSet = function (props: { optionMeta: PageOptionsMeta, pageOptions: TaskOption[], optionsIndex: number, updateOptions: (optID: string, index: number) => void }) {
	let indexSelected = 0;
	let optID = '';
	for (let i = 0; i < props.pageOptions.length; i++) {
		if (props.optionMeta.optionsId === props.pageOptions[i].optID) {
			indexSelected = props.pageOptions[i].optVal;
			optID = props.pageOptions[i].optID;
		}
	}
	if (optID === '') return null;
	let myOptionBoxes = props.optionMeta.options.map((option, index) => {
		let myKey = 'option-' + index;
		let isSelected = index === indexSelected;
		return <OptionCheckBox key={myKey} option={option} isSelected={isSelected} boxClick={() => { props.updateOptions(optID, index); }} />
	})

	return (
		<div className='teachers-taskcreater-options'>
			<span className='teachers-taskcreater-optionboxestext'>{props.optionMeta.label}</span>
			<span className='teachers-taskcreater-checkboxexplain'>{props.optionMeta.explain}</span>
			<div className='teachers-taskcreater-options-list'>
				{myOptionBoxes}
			</div>
		</div>
	)
};

const OptionCheckBox = function (props: { isSelected: boolean, boxClick: () => void, option: { optionIndex: number, optionDesc: string } }) {
	return (
		<div>
			<input className='teachers-taskcreater-checkbox' type="checkbox" checked={props.isSelected} onChange={() => { props.boxClick(); }}></input>
			<span className='teachers-taskcreater-checkboxtext'>{props.option.optionDesc}</span>
		</div>
	)
};
